import { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";

/**
 * Custom hook to determine if a video should be shown based on user's connection and source
 *
 * @returns {boolean} - Returns false if user is on mobile data or browsing from TikTok, true otherwise
 */
export const useShouldShowVideo = ({ requireWifi = true } = {}) => {
  const [shouldShowVideo, setShouldShowVideo] = useState(false);

  useEffect(() => {
    const isFromTikTok = /tiktok/i.test(navigator.userAgent);
    const connection =
      navigator.connection || navigator.webkitConnection || navigator.mozConnection;

    let isOnWifi = true; // default to true if connection info isn't available

    if (requireWifi && connection) {
      // Only treat it as WiFi if explicitly stated
      if (connection.type) {
        isOnWifi = connection.type === "wifi";
      } else if (connection.effectiveType) {
        // Assume anything less than 4g is not WiFi
        //   isOnWifi = connection.effectiveType === "4g";
        isOnWifi = false;
      }
    }

    const blockVideo = isFromTikTok || (requireWifi && isMobile && !isOnWifi);
    setShouldShowVideo(!blockVideo);
  }, [requireWifi]);

  return shouldShowVideo;
};
